import { render } from "./Main-Menu.vue?vue&type=template&id=20a39e52&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform"
import script from "./Main-Menu.vue?vue&type=script&lang=js"
export * from "./Main-Menu.vue?vue&type=script&lang=js"

import "./Main-Menu.vue?vue&type=style&index=0&id=20a39e52&lang=scss&scoped=true"

import exportComponent from "D:\\SVNproject\\qiankunMain\\cloud-pedestal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20a39e52"]])

export default __exports__